import type { ContractTemplate, VersionEntry } from "../types/contractTemplate";

export const mockContractTemplates: Record<string, ContractTemplate> = {
  "cd-001": {
    contractName: "Commercial_Insurance_Master_Agreement_2025",
    contractType: "Partnership Agreement",
    contractReviewer: "",
    contractOrigination: "",
    effectiveDate: "10-01-2025",
    sections: [
      {
        sectionName: "Definitions",
        businessUnit: ["All BUs", "On Call", "TMHCC", "MAM"],
        content: [
          {
            type: "clause",
            text: "This section defines key terms used throughout the contract. The term \"insured\" shall mean the named insured as specified in the declarations and any subsidiary companies thereof. \"Premium\" refers to the consideration paid by the insured to the insurer in exchange for the coverage provided under this Policy.\n\nThe \"Policy Period\" commences on the effective date specified in the declarations and continues for twelve (12) consecutive months, unless earlier terminated in accordance with the provisions of this Policy. The \"Coverage Limit\" represents the maximum amount the insurer shall be obligated to pay for all covered losses during the Policy Period.\n\n\"Occurrence\" means an accident, including continuous or repeated exposure to substantially the same general harmful conditions, which results in bodily injury, property damage, or personal and advertising injury.\n\n\"Claim\" means a demand received by the insured for money or services, including the service of suit or institution of arbitration proceedings against the insured.\n\nAll terms and conditions set forth in this Policy shall be interpreted in accordance with the laws of the jurisdiction specified in the declarations, without regard to its conflicts of law principles."
          },
          {
            type: "clause",
            text: "\"Named Insured\" means the person or organization shown in the Declarations as the named insured. \"Additional Insured\" means any person or organization that qualifies as an insured under the provisions of this Policy."
          },
          {
            type: "clause",
            text: "\"Bodily Injury\" means physical injury, sickness, or disease sustained by a person, including death resulting from any of these at any time."
          }
        ]
      },
      {
        sectionName: "Coverage",
        businessUnit: ["On Call", "TMHCC"],
        content: [
          {
            type: "clause",
            text: "The insurer agrees to pay on behalf of the insured all sums that the insured becomes legally obligated to pay as damages because of bodily injury or property damage to which this insurance applies."
          },
          {
            type: "clause",
            text: "This insurance applies to bodily injury and property damage only if the bodily injury or property damage is caused by an occurrence that takes place in the coverage territory during the policy period."
          }
        ]
      },
      {
        sectionName: "Exclusions",
        businessUnit: ["All BUs"],
        content: [
          {
            type: "clause",
            text: "This insurance does not apply to expected or intended injury, meaning bodily injury or property damage expected or intended from the standpoint of the insured."
          },
          {
            type: "clause",
            text: "This insurance does not apply to contractual liability assumed under any contract or agreement, except for liability that the insured would have in the absence of the contract."
          }
        ]
      },
      {
        sectionName: "Conditions",
        businessUnit: ["On Call", "MAM"],
        content: [
          {
            type: "clause",
            text: "In the event of an occurrence, the insured must promptly notify the insurer and provide all relevant details including the nature of the claim, the identity of any injured parties, and the circumstances surrounding the event."
          }
        ]
      }
    ]
  },
  "cd-002": {
    contractName: "Property_Liability_Service_Contract_Q1",
    contractType: "Partnership Agreement",
    contractReviewer: "Lisa Anderson",
    contractOrigination: "",
    effectiveDate: "01-01-2025",
    sections: [
      {
        sectionName: "Introduction",
        businessUnit: ["On Call", "SOW"],
        content: [
          {
            type: "clause",
            text: "This STATEMENT OF WORK (the 'SOW') is entered into as of October 1, 2021 ('Effective Date') by and between On Call International, a corporation (hereinafter referred to as 'On Call'), and the Client, on behalf of itself and its subsidiaries and affiliates."
          },
          {
            type: "clause",
            text: "The terms and conditions herein reflect the implied terms and conditions the parties have operated under between the Commencement Date and the Effective Date and shall govern the relationship between the Parties on and after the SOW's Effective Date."
          }
        ]
      },
      {
        sectionName: "Definitions",
        businessUnit: ["On Call", "SOW"],
        content: [
          {
            type: "clause",
            text: "Pursuant to the Agreement, as Client's designated travel assistance provider, On Call will administer this travel assistance services program and arrange for and/or provide the Services, in whole or in part, to each Eligible Participant."
          },
          {
            type: "clause",
            text: "If there are any conflicts in terms between the Agreement and this SOW, the terms in this SOW shall take precedence."
          }
        ]
      },
      {
        sectionName: "Schedules",
        businessUnit: ["SOW"],
        content: [
          {
            type: "clause",
            text: "This SOW contains the following Schedules, each attached hereto as listed and incorporated herein by this reference, as may be periodically amended:"
          },
          { type: "list_item", text: "Schedule A: Compensation" },
          { type: "list_item", text: "Schedule B: Services, Limitations, Terms and Conditions" },
          { type: "list_item", text: "Schedule C: Travel Insurance Plans" },
          { type: "list_item", text: "Schedule D: Service Activities and Personnel" }
        ]
      }
    ]
  }
};

export const mockVersions: VersionEntry[] = [
  { version: "v1", modifiedBy: "Michael Chen", date: "2025-11-20" }
];
